"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M2.5 2.08262C2.5 1.18929 3.19046 0.5 4 0.5H20C20.8095 0.5 21.5 1.18929 21.5 2.08262V21.9153C21.5 23.0635 20.4053 23.7855 19.4495 23.3874L12.935 20.674C12.3352 20.4242 11.6648 20.4242 11.065 20.674L4.55053 23.3874C3.59474 23.7855 2.5 23.0635 2.5 21.9153V2.08262Z", stroke: "black", strokeWidth: "1", fill: fill }, void 0) }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, size = _a.size, rest = __rest(_a, ["fill", "size"]);
    return (jsx_runtime_1.jsx(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: jsx_runtime_1.jsx("path", { d: "M3.41663 2.77682C3.41663 1.62854 4.30307 0.75 5.33329 0.75H26.6666C27.6968 0.75 28.5833 1.62854 28.5833 2.77682V29.2204C28.5833 30.6971 27.1794 31.6123 25.9646 31.1063L17.2787 27.4884C16.4584 27.1467 15.5415 27.1467 14.7212 27.4884L6.03529 31.1063C4.82056 31.6123 3.41663 30.6971 3.41663 29.2204V2.77682Z", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0) }), void 0));
};
var BannerIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.BannerIcon = BannerIcon;
//# sourceMappingURL=BannerIcon.js.map